import React from 'react'
import {PropTypes} from 'prop-types'

import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';

export const ButtonAddEntity = ({to = "", icon, iconSize = "md-18", onClick = "", linkClass = "", buttonClass = "", ...props}, context) => {

    const buttonClassName = (buttonClass)?"mb-2 mr-1 btn btn-white btn-sm btn-pill " +  buttonClass : "mb-2 mr-1 btn btn-white btn-sm btn-pill";
    const iconClassName = "material-icons " + iconSize;
    const addIcon = (icon)?icon:"playlist_add";

    return (    
        <Link to={to} className={linkClass}>
            <Button size="sm" theme="white" className={buttonClassName} {...props}>
                <b style={{fontSize: "13px", float: "left"}}>+</b><i className={iconClassName} >{addIcon}</i>
            </Button>
        </Link>
    )
}

ButtonAddEntity.contextTypes = {
    t: PropTypes.func
}

